<template>
  <ul class="c-regist__flow">
    <li
      v-for="step in steps"
      :key="`regist_flow_step_${step}`"
      class="c-regist__flow-list"
      :class="nowStep >= step ? '-active' : ''"
    >
      <span class="-small">Step&nbsp;</span>
      <span class="-big">{{ ('00' + step).slice(-2) }}</span>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RegisterFlow',
  props: {
    steps: {
      type: Number,
      default: 1,
    },
    nowStep: {
      type: Number,
      default: 1,
      required: true,
    },
  },
})
</script>

<style scoped></style>
